import { BUNDLE_ITEMOFFERING_GET_REQUEST } from '../actionTypes/BundleItemOfferingActionTypes';

const getItemOfferingAction = (payload) => ({
    type: BUNDLE_ITEMOFFERING_GET_REQUEST,
    payload,
});

export default getItemOfferingAction;
